import React, { useState, useEffect } from "react";
import { Input, Radio, Checkbox, Slider, Typography, Space, Segmented, Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import './formEvaluationAnswerGroup.css';

const { Text } = Typography;
const { TextArea } = Input;

const FormEvaluationAnswerGroupText = ({
    index,
    evaluationAnswerGroup,
    showEdit,
    onEdit,
    onDelete
}) => {
    const [eagTitle, setEagTitle] = useState(evaluationAnswerGroup.eag_title || "");
    const [eagDescription, setEagDescription] = useState(evaluationAnswerGroup.eag_description || "");
    const [eagType, setEagType] = useState(evaluationAnswerGroup.eag_type || null);
    const [eagMinValue, setEagMinValue] = useState(evaluationAnswerGroup.eag_min_value || 1);
    const [eagMaxValue, setEagMaxValue] = useState(evaluationAnswerGroup.eag_max_value || 5);
    const [eagOptions, setEagOptions] = useState(evaluationAnswerGroup.eag_options || []);

    useEffect(() => {
            setEagTitle(evaluationAnswerGroup.eag_title || "");
            setEagDescription(evaluationAnswerGroup.eag_description || "");
            setEagType(evaluationAnswerGroup.eag_type ?? null);
            setEagMinValue(evaluationAnswerGroup.eag_min_value ?? 1);
            setEagMaxValue(evaluationAnswerGroup.eag_max_value ?? 5);
            setEagOptions(evaluationAnswerGroup.eag_options || []);
        }, [evaluationAnswerGroup]);

    const renderOptions = () => {
        if (eagType === 1) {
            return (
                <Radio.Group style={{ width: "100%", display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {eagOptions.map((option, idx) => (
                        <Radio key={idx} value={option.eao_value}>
                            {option.eao_option}. {option.eao_text}
                        </Radio>
                    ))}
                </Radio.Group>
            );
        }

        if (eagType === 2) {
            return (
                <Checkbox.Group style={{ width: "100%" }}>
                    {eagOptions.map((option, idx) => (
                        <Checkbox key={idx} value={option.eao_value}>
                            {option.eao_option}. {option.eao_text}
                        </Checkbox>
                    ))}
                </Checkbox.Group>
            );
        }

        if (eagType === 4) {
            const numericOptions = [];
            for (let i = eagMinValue; i <= eagMaxValue; i++) {
                numericOptions.push(i);
            }
            return (
                <Segmented block options={numericOptions} className="custom-segmented" />
            );
        }

        return null;
    };

    return (
        <Space direction="vertical" size="middle" style={{ width: "100%", margin: "0 auto" }}>
            {showEdit && (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Text strong type="secondary">{eagTitle}</Text>
                    <div style={{ display: "flex", gap: 8 }}>
                        <Button icon={<EditOutlined />} size="small" onClick={() => onEdit(evaluationAnswerGroup)}>Editar</Button>
                        <Button icon={<DeleteOutlined />} size="small" danger onClick={() => onDelete(evaluationAnswerGroup)}>Eliminar</Button>
                    </div>
                </div>
            )}
            <Text>{eagDescription}</Text>
            {renderOptions()}
        </Space>
    );
};

export default FormEvaluationAnswerGroupText;
